import type { DataTableColumn } from '@/components/ui/data-table-customized'
import { Scope } from '../../../types'

export const getScopeColumns = (): DataTableColumn<Scope>[] => [
    {
        key: 'name',
        title: 'Name',
        width: 250,
    },
    {
        key: 'displayName',
        title: 'Display Name',
        width: 300,
        valueGetter: (row) => row.displayName || '-',
    },
]
